import { fg } from '@atlassian/jira-feature-gating';

const TimelineStickyAssigneeStatusColumnRelayProvider = {
	get(): boolean {
		return fg('jira_timeline_sticky_assignee_status_columns');
	},
};

export default TimelineStickyAssigneeStatusColumnRelayProvider;
